// extracted by mini-css-extract-plugin
export default {"section":"addExerciseToUser_section__hkSn1","header":"addExerciseToUser_header__7mB+w","exercises":"addExerciseToUser_exercises__CDqxT","list":"addExerciseToUser_list__MEQZt"};